import {settingsDropdownOptionsSelector} from '../Settings/settingsFunctions.js'
import {companyNameSelector, companyIDSelector} from '../../data/company.js'
import {currentDropdownSelector} from '../../redux/selectors/ui/index.js'
import {emailSelector, logout} from '../../data/me.js'
import {useSelector} from '../../store.js'
import Icon from '../../common/icons/Icon.js'
import {useRef} from 'react'
import Zropdown, {
  useZropdown,
  useZropdownElement,
} from '../../common/components/Zropdown.js'
import className from '../../common/className.js'
import useStable from '../../common/useStable.js'

function Item({item, isFocused}) {
  const ref = useRef()

  useZropdownElement({ref, isSelected: isFocused})

  return (
    <li ref={ref} className="list__item list__item--dropdown">
      <div
        className={className`wrap--dropdown-item flex--justify-nowrap label--selectable label--selectable-pt-pb-0 margin-bottom-0 ${{
          'list__link--dropdown-arrow-focus': isFocused,
        }}`}
      >
        <a
          className={`list__link list__link--dropdown ${{active: item.selected}}`}
          href={item.url}
        >
          <span className="make-block fs-n0">{item.dropdownDisplay}</span>
        </a>
      </div>
    </li>
  )
}

export default function SettingsDropdown() {
  const dropdown = 'settings_dropdown'
  const currentDropdown = useSelector(currentDropdownSelector)
  const companyName = useSelector(companyNameSelector)
  const email = useSelector(emailSelector)
  const companyID = useSelector(companyIDSelector)
  const itemOptions = useStable(useSelector(settingsDropdownOptionsSelector))

  const buttonRef = useRef()

  const {form, onConfirm, onUp, onDown} = useZropdown({
    dropdown,
    list: itemOptions,
    onSelect: (item) => {
      window.location.hash = item.url
    },
    closeOnConfirm: true,
  })

  return (
    <li className="flex align-items-center utility-nav__item">
      <div
        className={className`${{
          open: currentDropdown === dropdown,
        }}`}
        data-dropdown={dropdown}
      >
        <button
          id={dropdown}
          ref={buttonRef}
          className="btn btn--ko-dropdown utility-nav__link utility-nav__link--settings"
          type="button"
        >
          <Icon name="sym-settings" className="fs-01" />{' '}
          <strong className="btn__text btn__text--company">
            {companyName}
          </strong>{' '}
        </button>
        <Zropdown
          dropdown={dropdown}
          parentRef={buttonRef}
          onConfirm={onConfirm}
          onUp={onUp}
          onDown={onDown}
          header={
            <>
              <div className="zropdown__header" data-dropdown-prevent-close>
                <ul className="wrap--support-pin margin-bottom-0">
                  <li className="list__item list__item--dropdown no-border fs-n0">
                    <strong className="make-block">{email}</strong>
                  </li>
                  <li className="list__item list__item--dropdown no-border fs-n0">
                    <strong>Support PIN:</strong>
                    {` ${companyID}`}
                  </li>
                </ul>
              </div>
            </>
          }
          footer={
            <>
              <div className="list__item list__item--dropdown list__item--dropdown-last">
                <button
                  className="btn--link list__link list__link--dropdown list__link--logout fs-n0"
                  type="button"
                  onClick={() => logout()}
                >
                  Logout
                </button>
              </div>
            </>
          }
          blurOnOpen
        >
          {form.results.map((item, index) => (
            <Item
              key={index}
              item={item}
              isFocused={index === form.selectedIndex}
            />
          ))}
        </Zropdown>
      </div>
    </li>
  )
}
